export default "/_next/static/images/product-bots-60481a89130372ec53d314a3152d3fca.svg";